import * as moment from 'moment';
import {DateTimeFormat} from '../components/esp-datefield/models/date-formats';

export class DateService {

  static isToday(firstDate: Date, secondDate: Date): boolean {
    return firstDate.toDateString() === secondDate.toDateString();
  }

  static hoursDiff(firstDate: Date, secondDate: Date, absOpt?: boolean): number {
    if (absOpt === true) {
      return Math.abs((firstDate.getTime() - secondDate.getTime()) / (1000 * 3600));
    } else {
      return (firstDate.getTime() - secondDate.getTime()) / (1000 * 3600);
    }
  }

  static daysDiff(firstDate: Date, secondDate: Date, absOpt?: boolean): number {
    if (absOpt === true) {
      return Math.ceil(Math.abs(firstDate.getTime() - secondDate.getTime()) / (1000 * 3600 * 24));
    } else {
      return Math.ceil(firstDate.getTime() - secondDate.getTime() / (1000 * 3600 * 24));
    }
  }

  static yearsDiff(firstDate: Date, secondDate: Date): number {
    let diff = (firstDate.getTime() - secondDate.getTime()) / 1000;
    diff /= (60 * 60 * 24);
    return Math.abs(Math.round(diff / 365.25));
  }

  static timeDiff(firstDate: Date, secondDate: Date): number {
    return firstDate.getTime() - secondDate.getTime();
  }

  static compareDate(firstDate: Date, secondDate: Date): boolean {
    if (firstDate >= secondDate) {
      return true;
    } else {
      return false;
    }
  }

  static shiftToLocalAsUTC(date: Date): Date {
    const datetime = moment(date.getTime()).format(DateTimeFormat.FULL_DATETIME_minus);
    return new Date(`${datetime}+00:00`);
  }
}
